<template>
  <div
    :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
    :style="{
      'padding-top': paddingTop + 'px',
      'padding-bottom': paddingBottom + 'px',
      'background-color': useBackgroundColor
    }"
    @click="$emit('block:redirect')"
  >
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="mainFields.code?.value" />
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  mixins: [staticBlockMixin]
}
</script>
